export default __webpack_public_path__ + "static/passkit-presentation-cards-6cb2be1ef78387c34d26d6ef03c8c556.png";